import * as Onboarding from '../_layout/OnboardingComponents'
import { InvestorSignatureContent } from '../investor-signature/_layout/InvestorSignatureContent'
import { InvestorSignatureSideMenu } from '../investor-signature/_layout/InvestorSignagtureSideMenu'

function InvestorSignaturePage() {
  return (
    <Onboarding.Container>
      <Onboarding.ContainerContent>
        <InvestorSignatureContent />
      </Onboarding.ContainerContent>

      <Onboarding.ContainerSideMenu>
        <InvestorSignatureSideMenu />
      </Onboarding.ContainerSideMenu>
    </Onboarding.Container>
  )
}

export default InvestorSignaturePage
